import Service from './service'
export var ApiInteractionMessageType;
(function (ApiInteractionMessageType) {
  ApiInteractionMessageType["INTERACTION_STATE"] = "system.interaction.state"
  ApiInteractionMessageType["INTERACTION_CONTROL"] = "system.interaction.control"
})(ApiInteractionMessageType || (ApiInteractionMessageType = {}))
export var InteractionMessageType;
(function (InteractionMessageType) {
  InteractionMessageType["INTERACTION_START"] = "INTERACTION_START"
  InteractionMessageType["INTERACTION_STOP"] = "INTERACTION_STOP"
})(InteractionMessageType || (InteractionMessageType = {}))
export var InteractionReason;
(function (InteractionReason) {
  /** Речь человека */
  InteractionReason[InteractionReason["HumanSpeech"] = 0] = "HumanSpeech"
  /** Лицо человека */
  InteractionReason[InteractionReason["HumanFace"] = 1] = "HumanFace"
  /** Нажатие на элемент GUI */
  InteractionReason[InteractionReason["GUIClick"] = 2] = "GUIClick"
  /** Пришел источник из HARKа */
  InteractionReason[InteractionReason["HARK"] = 3] = "HARK"
  /** Пользовательский тип */
  InteractionReason[InteractionReason["User"] = 100] = "User"
})(InteractionReason || (InteractionReason = {}))
/**
 * Сервис для работы со взаимодействием
 * @version 0.0.1
 * @since 1.9.0
 */
export default class InteractionService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiInteractionMessageType.INTERACTION_STATE:
          if (message.state === 'Interaction') {
            this.broadcast(InteractionMessageType.INTERACTION_START, message.Reason)
          }
          else if (message.state === 'NonInteraction') {
            this.broadcast(InteractionMessageType.INTERACTION_STOP)
          }
          break
      }
    }
    this.messageChannel.subscribe(ApiInteractionMessageType.INTERACTION_STATE, messageHandler)
  }
  /**
     * Событие о начале взаимодействия
     *
     * Взаимодействие может начаться по (настраивается на роботе):
     * 1. Робот распознал речь
     * 2. Робот распознал лицо человека
     * 3. Пользователь нажал на элемент GUI
     *
     * Данное событие может прийти только после:
     * 1. Загрузки GUI робота
     * 2. После того как было событие о завершении интеракции `robot.interactionService.onStop`
     *
     * Если в момент интеракции был вызван метод `robot.interactionService.start()` - callback не отработает
     *
     * @since 1.9.0
     * @param {(reason: InteractionReason) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof InteractionService
     *
     * @example <caption>Событие о начале взаимодействия</caption>
     * robot.interactionService.onStart((reason) => {
     *   ...
     * })
     */
  onStart(callback) {
    return this.subscribe(InteractionMessageType.INTERACTION_START, callback)
  }
  /**
     * Сообщение об окончании взаимодействия
     *
     * Данное сообщение можно интерпретировать как то, что перед роботом нет людей
     *
     * Может быть инициировано двумя способами:
     * 1. Закончился таймаут интеракции (настраивается на роботе)
     * 2. Был вызван метод `robot.interactionService.stop()`
     *
     * @since 1.9.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof InteractionService
     *
     * @example <caption>Сообщение о окончании взаимодействия</caption>
     * robot.interactionService.onStop(() => {
     *   ...
     * })
     */
  onStop(callback) {
    return this.subscribe(InteractionMessageType.INTERACTION_STOP, callback)
  }
  /**
     * Начать/продлить взаимодействие
     *
     * При продлении интеракции callback onStart не сработает
     *
     * @since 1.9.0
     * @memberof InteractionService
     *
     * @example <caption>Начать взаимодействие</caption>
     * robot.interactionService.start()
     */
  start() {
    this.messageChannel.send({
      type: ApiInteractionMessageType.INTERACTION_CONTROL,
      state: 'Start',
    })
  }
  /**
     * Завершить взаимодействие
     *
     * @since 1.9.0
     * @memberof InteractionService
     *
     * @example <caption>Завершить взаимодействие</caption>
     * robot.interactionService.stop()
     */
  stop() {
    this.messageChannel.send({
      type: ApiInteractionMessageType.INTERACTION_CONTROL,
      state: 'Stop',
    })
  }
}
